import _store from 'store2'
import {addCalendar, deleteCalendar, getCalendarList, queryById, updateCalendar} from "@/api/calendar";
import {ElMessage} from "element-plus";
import {
    auditExternalPerson,
    getMessageList,
    getUnReadMessageList,
    isReadAll, messageQueryById, updateMessageInfo, updateReadCount
} from "@/api/message";
import {replaceKeys} from "@/utils/mes";
import {queryNoticeList} from "@/api/home";

const stableStringify = (value) => {
    if (value === null || value === undefined) {
        return String(value)
    }
    if (typeof value !== 'object') {
        return JSON.stringify(value)
    }
    if (Array.isArray(value)) {
        return `[${value.map(stableStringify).join(',')}]`
    }
    const keys = Object.keys(value).sort()
    return `{${keys.map(key => `${JSON.stringify(key)}:${stableStringify(value[key])}`).join(',')}}`
}

const getMessageUniqueKey = (item) => {
    if (!item || typeof item !== 'object') return ''
    const directId = item.id ?? item.messageId ?? item.noticeId ?? item._id ?? item.msgId
    if (directId !== undefined && directId !== null && String(directId).trim() !== '') {
        return `id:${String(directId)}`
    }
    return `snapshot:${stableStringify(item)}`
}

const dedupeMessageList = (list = []) => {
    const result = []
    const seen = new Set()
    for (const item of Array.isArray(list) ? list : []) {
        const key = getMessageUniqueKey(item)
        const finalKey = key || `raw:${String(item)}`
        if (seen.has(finalKey)) continue
        seen.add(finalKey)
        result.push(item)
    }
    return result
}

const message = {
    namespaced: true,
    state: {
        allDataList: [],
        allDataTotal: 0,
        allDataIsLoading: false,
        newData: [],
        allNewData: 0,
        allNewDataIsLoading: false,
        emailData: [],
        currentMessage: {},
        announcementInfo: 0,
        notifyList: [],
        notifyListSetting: {
            pageNo: 1,
            pageSize: 12,
            totalPages: 0,
            total: 0,
            isCurrent: false,
        },
    },
    getters: {},
    mutations: {
        setNotifyList(state, payload) {
            state.notifyList = payload
        },
        setNotifyListSetting(state, payload) {
            const {type, value} = payload
            state.notifyListSetting[type] = value
        },
        setAnnouncementInfo(state, payload) {
            state.announcementInfo = payload
        },
        setAllDataList(state, payload) {
            state.allDataList = payload;
        },
        setNewData(state, payload) {
            try {
                const source = typeof payload === 'string' ? JSON.parse(payload) : payload
                const res = replaceKeys(source)
                const currentList = Array.isArray(state.newData) ? state.newData : []
                const nextList = dedupeMessageList([res, ...currentList])
                console.log(res, 'res')
                state.newData = nextList
            } catch (e) {
                console.warn('setNewData 解析消息失败:', e)
            }
        },
        resetNewData(state, payload) {
            state.newData = payload;
        },
        //     邮件信息
        setEmailData(state, payload) {
            state.emailData = payload;
        }
    },
    actions: {
        // 列表查询-all
        async getMessageListApis({state, dispatch, rootState}, payload) {
            state.allDataIsLoading = true
            const res = await getMessageList(payload)
            if (res.code !== 200) {
                ElMessage.error(res.message)
                return
            }
            state.allDataIsLoading = false;
            console.log(res.result.records, 'res.result.records')
            state.allDataTotal = res.result.total;
            state.allDataList = [...state.allDataList, ...res.result.records];
            // state.allDataList = res.result.records
        },
        // 初始化全部数据
        async getMessageListApisDefault({state, dispatch, rootState}, payload) {
            state.allDataIsLoading = true
            const res = await getMessageList(payload)
            if (res.code !== 200) {
                ElMessage.error(res.message)
                return
            }
            state.allDataIsLoading = false;
            console.log(res.result.records, 'res.result.records')
            state.allDataTotal = res.result.total;
            // state.allDataList = [...state.allDataList, ...res.result.records];
            state.allDataList = res.result.records
        },

        //    未读数据
        async getUnReadMessageListApis({state, dispatch, rootState}, payload) {
            const {pageNo, pageSize, isUpdate} = payload
            state.allNewDataIsLoading = true;
            let res = await getUnReadMessageList({pageNo, pageSize})
            if (res.code !== 200) {
                ElMessage.error(res.message);
                return
            }
            state.allNewDataIsLoading = false;
            state.allNewData = res.result.total;
            const nextRecords = dedupeMessageList(res.result.records || [])
            if (isUpdate || Number(pageNo) <= 1) {
                state.newData = nextRecords
            } else {
                state.newData = dedupeMessageList([...(state.newData || []), ...nextRecords])
            }
            // sessionStorageUtil.setItem("getUnReadMessageListData", {
            //     newData: state.newData,
            //     allNewData: state.allNewData
            // })
        },
        // 初始化数据
        async getUnReadMessageListApisDefault({state, dispatch, rootState}, payload) {
            let res = await getUnReadMessageList(payload)
            if (res.code !== 200) {
                ElMessage.error(res.message);
                return
            }
            state.allNewData = res.result.total;
            state.newData = dedupeMessageList(res.result.records || [])
        },
        //     是否同意进入团队？
        async auditExternalPersonApis({state, dispatch, rootState}, payload) {
            let res = await auditExternalPerson(payload);
            if (res.code !== 200) {
                ElMessage.error(res.message);
                return;
            }
            ElMessage.success(res.message)
        },

        //     一键已读
        async isReadAllApis({state, dispatch,}, payload) {
            const res = await isReadAll();
            if (res.code !== 200) {
                ElMessage.error(res.message);
                return
            }
        },

        //  单条消息 更新已读状态
        async updateMessageInfoApi({state, dispatch}, payload) {
            const res = await updateMessageInfo(payload)
            if (res.code !== 200) {
                ElMessage.error(res.message);
                return
            }
        },

        //     获取消息详情
        async messageQueryById({state, dispatch}, payload) {
            const res = await messageQueryById(payload)
            if (res.code !== 200) {
                ElMessage.error(res.message);
                return
            }
            console.log(res, 'res')
            state.currentMessage = res.result || {}
        },
        async queryNoticeListApis({state, dispatch}, payload) {
            const {isCurrent} = payload
            const res = await queryNoticeList({
                pageNo: state.notifyListSetting.pageNo,
                pageSize: state.notifyListSetting.pageSize,
                type: 3,
            })
            if (res.code !== 200) {
                ElMessage.error(res.message)
                return
            }
            const {records} = res.result.data
            if (!isCurrent) {
                state.notifyList = records;
            } else {
                state.notifyList = [...state.notifyList, ...records]
            }
            state.notifyListSetting.totalPages = res.result?.data?.pages;
            state.notifyListSetting.total = res.result?.data?.total;
            state.announcementInfo = res.result?.data?.total;
            state.unReadData = res.result.unReadData
        },
        async queryNoticeListApisUnRead({state,}, payload) {
            const res = await queryNoticeList(payload)
            if (res.code !== 200) {
                ElMessage.error(res.message)
                return
            }
            state.unReadData = res.result.unReadData
        },
        //     更新阅读状态
        async updateReadCountApis({state, dispatch}, payload) {
            const res = await updateReadCount(payload)
            if (res.code !== 200) {
                ElMessage.error(res.message)
                return
            }
        }
    },
}

export default message;
